import { AccessRightService } from '../../../shared/fi-shared-services';
import { IAccessRightFilterCollection } from '../../../shared/models';
import { fiItemsFlatten } from '@fi-shared/utils/fi-items-flatten';

export const FiCoreUserUnitResolve_accessRightFilterCollection = [
    AccessRightService,
    (accessRightService: AccessRightService) => accessRightService.GetAccessRightsForUser(),
];

export const FiCoreUnitResolve_lightWeightBusinessUnits = [
    'accessRightFilterCollection',
    (accessRightFilterCollection: IAccessRightFilterCollection) =>
        accessRightFilterCollection.AccessRightCoreFilter.BusinessUnits,
];

export const FiCoreUnitResolve_lightWeightBusinessAreas = [
    'accessRightFilterCollection',
    (accessRightFilterCollection: IAccessRightFilterCollection) =>
        accessRightFilterCollection.AccessRightCoreFilter.BusinessAreas,
];

export const FiCoreUnitResolve_lightWeightAreas = [
    'accessRightFilterCollection',
    (accessRightFilterCollection: IAccessRightFilterCollection) => {
        const flattenAreas = fiItemsFlatten(accessRightFilterCollection.AccessRightCoreFilter.Areas);
        return flattenAreas;
    },
];

export const FiCoreUnitResolve_lightWeightClusters = [
    'accessRightFilterCollection',
    (accessRightFilterCollection: IAccessRightFilterCollection) =>
        accessRightFilterCollection.AccessRightCoreFilter.Clusters,
];
